import type { NextPage } from 'next'
// import { useRouter } from 'next/router'
// import Dayjs from '../../dayjs'
import style from './item.module.css'

// import Link from 'next/link'
// import type { Item } from '../../../modules/project'
// import { useState } from 'react'

import AttachFileTable from './AttachFileTable'
import BlankPage from './blank'
import {PreparationForm} from "@/modules/project";
import Dayjs from "@/components/dayjs";
import File from "@/components/files";


interface IProps {
    className?: string,
    item?: PreparationForm
}

const Component: NextPage<IProps> = ({ className , item}) => {
  const title = '평가준비서'
  return (
    <section className={className || ''}>
      <h3 className={style.h3}>
        {title}
      </h3>
      {item && item.idx
          ? (
              <>
                <div>
                  <table className={`${style.baseInfoTable} border-t-2 border-t-gg-blue`}>
                    <colgroup>
                      <col width={200}/>
                      <col width={400}/>
                      <col width={200}/>
                      <col width={400}/>
                    </colgroup>
                    <tbody>
                    <tr>
                      <th>환경영향평가업체</th>
                      <td>{item.environmentalEvaluationCompany? item.environmentalEvaluationCompany:  "-"}</td>
                      <th>결정내용공개 공고일</th>
                      <td>
                          <Dayjs format="dateDot">{item.publicDisplayStartDate}</Dayjs>
                            ~
                          <Dayjs format="dateDot">{item.publicDisplayEndDate}</Dayjs>
                      </td>
                    </tr>
                    <tr>
                      <th>공람기간</th>
                      <td>
                          <Dayjs format="dateDot">{item.publicDisplayStartDate}</Dayjs>
                          ~
                          <Dayjs format="dateDot">{item.publicDisplayEndDate}</Dayjs>
                      </td>
                      <th>의견제출기간</th>
                      <td>
                          <Dayjs format="dateDot">{item.submissionOfOpinionStartDate}</Dayjs>
                          ~
                          <Dayjs format="dateDot">{item.submissionOfOpinionEndDate}</Dayjs>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div className='my-8'>
                  <AttachFileTable title="평가서" items={item.files}/>
                </div>
              </>
          ) :
          (
              <BlankPage title={title} className="mb-12" />
          )}
    </section>
  )
}

export default Component
